<template>
  <div class="tip-icon" :style="Style">
    <div v-if="state==true">
      <i class="icon el-icon-success" />
    </div>
    <div v-if="state==false">
      <i class="icon el-icon-error" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: true,
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    Style() {
      switch (this.step) {
        case 0:
          return {
            left: '0px',
          };
        case 1:
          return {
            left: '35%',
          };
        case 2:
          return {
            right: '0px',
          };
        default: return {};
      }
    },
  },
};
</script>
<style lang="less"  scoped >
.tip-icon {
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    margin-top: 10px;
    background: #ffffff;

    .icon {
      font-size: 20px;
    }
    .el-icon-success {
      color: var(--ui-main-color);
    }
    .el-icon-error {
      color: #D8D8D8;
    }
}
</style>
